import {
  backend_url,
  uninterceptedAxiosInstance,
} from "../common/commonVariables";

export const createNewAsset = async (
  name,
  description,
  model,
  category,
  area,
  serialNumber,
  barcode,
  vendor,
  customer,
  placedDate,
  warrantyExpirationDate,
  additionalInformation,
  image,
  warrantyFile,
  qrcode,
  organisation = "",
  procedure = null,
  createdByUser = null,
  location = null,
  subLocations = null,
  purchasePrice,
  manufacturer,
  descriptionRate,
  estimatedUsefulLife,
  peoples,
  teams,
  isChild,
  parentAsset
) => {
  try {
    let params = {
      name,
      description,
      model,
      categories: category,
      area,
      serialNumber,
      barcode,
      vendor,
      customer,
      placedDate,
      warrantyExpirationDate,
      additionalInformation,
      qrcode,
      organisation,
      procedure,
      createdByUser,
      location,
      subLocations,
      purchasePrice,
      manufacturer,
      descriptionRate,
      estimatedUsefulLife,
      peoples,
      teams,
      barcode,
      parentAsset,
      warrantyFile,
      isChild,
    };

    if (image)
      params = {
        ...params,
        image: image,
      };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "assets",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const createBulkAsset = async (data = [], organisationId = null) => {
  try {
    let params = {
      data,
      organisation: organisationId,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "assets/import",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
      error: err?.response?.data?.error?.message,
    };
  }
};

export const updateAssetsStatus = async (
  id,
  assetsStatus,
  dispose,
  organisation,
  clickButtonFlag = ""
) => {
  try {
    let params = {
      data: {
        status: assetsStatus,
        organisation,
      },
    };
    if (assetsStatus) {
      params.data.clickButton = clickButtonFlag;
    }

    if (dispose) {
      params.data.dispose = {
        reason: dispose.reason,
        costs: Number(dispose.costs),
      };
    }

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "assets/update-status/" + id,
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );


    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const deleteAsset = async (ID, reason) => {
  try {
    let params = {
      data: [
        {
          id: ID,
          deleteReason: reason,
        },
      ],
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "assets/removeAssets",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const updateAsset = async (
  id,
  name,
  description,
  model,
  category,
  area,
  serialNumber,
  barcode,
  vendor,
  customer,
  placedDate,
  warrantyExpirationDate,
  additionalInformation,
  image,
  warrantyFile,
  qrcode,
  procedure = null,
  location = null,
  subLocations = null,
  purchasePrice,
  manufacturer,
  descriptionRate,
  estimatedUsefulLife,
  peoples,
  teams,
  organisation,
  isChild,
  parentAsset
) => {
  try {
    let params = {
      name,
      description,
      model,
      categories: category,
      area,
      serialNumber,
      barcode,
      vendor,
      customer,
      placedDate,
      warrantyExpirationDate,
      additionalInformation,
      image,
      warrantyFile,
      qrcode,
      procedure,
      location,
      subLocations,
      purchasePrice,
      manufacturer,
      descriptionRate,
      estimatedUsefulLife,
      peoples,
      teams,
      organisation,
      isChild,
      parentAsset,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "assets/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};
